
const nominalText: string = 'Nominal'
const lowText: string = 'Low'
const mediumLowText: string = 'Medium Low'
const mediumText: string = 'Medium'
const mediumHighText: string = 'Medium High'
const highText: string = 'High'

const settingTexts1: string[] = [nominalText]
const settingTexts2: string[] = [lowText, highText]
const settingTexts3: string[] = [lowText, mediumText, highText]
const settingTexts4: string[] = [lowText, mediumLowText, mediumHighText, highText]

export function getEquipmentSettingText(settingsCount: number, settingsIndex: number): string|undefined {
    if (settingsIndex >= 0 && settingsIndex < settingsCount) {
        if (settingsCount === 1) {
            return settingTexts1[settingsIndex]
        } else if (settingsCount === 2) {
            return settingTexts2[settingsIndex]
        } else if (settingsCount === 3) {
            return settingTexts3[settingsIndex]
        } else if (settingsCount === 4) {
            return settingTexts4[settingsIndex]
        }
    }

    return undefined
}